import { render, staticRenderFns } from "./prd_out_two.vue?vue&type=template&id=f7183156&scoped=true&"
import script from "./prd_out_two.vue?vue&type=script&lang=js&"
export * from "./prd_out_two.vue?vue&type=script&lang=js&"
import style0 from "./prd_out_two.vue?vue&type=style&index=0&id=f7183156&scoped=true&lang=less&"
import style1 from "./prd_out_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7183156",
  null
  
)

export default component.exports